import validator from "validator";

export const required = value => (value ? undefined : "Required");

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const email = value => (value && !validator.isEmail(value) ? "Invalid email address" : undefined);

//this may seem counter intuitive but having unbound validation doesn't work for some reason.
export const maxLength80 = maxLength(80);
export const maxLength140 = maxLength(140);
export const minLength8 = minLength(8);



// WEBPACK FOOTER //
// ./src/util/formValidations.js